import { ClientFormSchema } from '@src/clients/schemas/ClientFormSchema';
import { OptionalBooleanField } from '@src/permitField/PermitFields';
import * as yup from 'yup';

export class IsAgencyField extends OptionalBooleanField {
  public static fieldName = 'isAgency' as const;
}

export const AdminClientFormSchema = yup
  .object()
  .shape({
    [IsAgencyField.fieldName]: IsAgencyField.validator,
  })
  .concat(ClientFormSchema);
